import { environment } from '../../../environments/environment';
import { Privilege } from './privilege';
import { RoleUserActivity } from './role-user-activity';

export class Role {
  constructor(
    public code?: string,
    public name?: string,
    public operational?: boolean,
    public imagePath?: string,
    public roleUserActivities?: RoleUserActivity[],
    public privileges?: Privilege[]
  ) { }

  clone() {
    return new Role (
      this.code,
      this.name,
      this.operational,
      this.imagePath,
      this.roleUserActivities,
      this.privileges
    );
  }

  get imageUrl() {
    return `${ environment.imageUrl }${ this.imagePath }`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/role.ts